import Vue from 'vue'
import Router from 'vue-router'
import index from './model/index'
import online from './model/online'
import org from './model/org'
import user from './model/user'
import guide from './model/guide'
import my from './model/my'
import error from './model/error'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    ...index,
    ...online,
    ...org,
    ...user,
    ...guide,
    ...my,
    ...error
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js